import React from 'react';
import memoizeOne from 'memoize-one';
import FilterSearch from '@jira/platform__filter-search-with-analytics/src/FilterSearchWithAnalytics.tsx';
import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import type { FilterViewProps } from '@atlassian/jira-directory-base/src/model/index.tsx';
import GroupPicker from '@atlassian/jira-group-picker/src/index.tsx';
import ProjectPicker from '@atlassian/jira-project-picker/src/index.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import UserPicker from '@atlassian/jira-user-picker/src/index.tsx';
import { initialQuery } from '../../../model/constants.tsx';
import { getAtlassianAccountId } from '../../../state/selectors/app/index.tsx';
import {
	getFilter,
	getSearchQuery,
	getSelectedProject,
	getSelectedGroup,
	getSelectedOwner,
	isFilterApplied,
} from '../../../state/selectors/query/index.tsx';
import type { State } from '../../../state/types.tsx';
import Clear from './clear/view.tsx';
import Filter from './view.tsx';

const SearchWithAnalytics = withFireUiAnalytics({ onChange: 'search' })(FilterSearch);
const OwnerPickerWithAnalytics = withFireUiAnalytics({ onChange: 'owner' })(UserPicker);
const ProjectTypePickerWithAnalytics = withFireUiAnalytics({ onChange: 'project' })(ProjectPicker);
const GroupPickerWithAnalytics = withFireUiAnalytics({ onChange: 'group' })(GroupPicker);

const renderFilterSearch =
	(state: State) =>
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(props: any): React.JSX.Element => (
		<SearchWithAnalytics
			{...props}
			value={getSearchQuery(state)}
			isAlwaysExpanded
			placeholderAlwaysVisible
			shouldFitContainerWidth
		/>
	);

const renderOwnerPicker =
	(state: State) =>
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(props: any): React.JSX.Element => (
		<OwnerPickerWithAnalytics
			{...props}
			selectedUser={getSelectedOwner(state)}
			suggestedAccountId={getAtlassianAccountId(state)}
			isCompact
			shouldFitContainer
			noPortal
		/>
	);

const renderProjectPicker =
	(state: State) =>
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(props: any): React.JSX.Element => (
		<ProjectTypePickerWithAnalytics
			{...props}
			selectedProject={getSelectedProject(state)}
			isCompact
			width="100%"
			noPortal
		/>
	);

const renderGroupPicker =
	(state: State) =>
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	(props: any): React.JSX.Element => (
		<GroupPickerWithAnalytics
			{...props}
			selectedGroup={getSelectedGroup(state)}
			isCompact
			width="100%"
			noPortal
		/>
	);

// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const renderClear = (state) => (props: any) => isFilterApplied(state) && <Clear {...props} />;

const mapStateToPropsFactory = () => {
	const renderFilterSearchFactory = memoizeOne(renderFilterSearch);
	const renderOwnerPickerFactory = memoizeOne(renderOwnerPicker);
	const renderProjectPickerFactory = memoizeOne(renderProjectPicker);
	const renderGroupPickerFactory = memoizeOne(renderGroupPicker);
	const renderClearFactory = memoizeOne(renderClear);
	return (state: State, ownProps: FilterViewProps<string>) => ({
		renderFilterSearch: renderFilterSearchFactory(state),
		renderOwnerPicker: renderOwnerPickerFactory(state),
		renderProjectPicker: renderProjectPickerFactory(state),
		renderGroupPicker: renderGroupPickerFactory(state),
		renderClear: renderClearFactory(state),
		initialFilter: initialQuery.filter,
		value: getFilter(state),
		onChange: ownProps.onFilter,
	});
};

export default connect(
	mapStateToPropsFactory,
	{},
	// @ts-expect-error - TS2345 - Argument of type 'ComponentType<Diff<Record<any, any> | (Record<any, any> & { children?: ReactNode; }), InjectIntlVoidProps>>' is not assignable to parameter of type 'Component<{ renderFilterSearch: (props: any) => Element; renderOwnerPicker: (props: any) => Element; renderProjectPicker: (props: any) => Element; renderGroupPicker: (props: any) => Element; renderClear: (props: any) => false | Element; initialFilter: Filter | undefined; value: Filter; onChange: (arg1: string) => vo...'.
)(Filter);
